$(document).ready(function () {
  $(window).on('load resize', function () {
    var vh = window.innerHeight * 0.01;
    var vw = window.innerWidth * 0.01;
    document.documentElement.style.setProperty('--vwbrower', `${vw}px`);
    document.documentElement.style.setProperty('--vhbrower', `${vh}px`);
  });
  if ($('.template-collection .sub-collections-slider .item').length) {
    $('.template-collection .sub-collections-slider').slick({
      slidesToShow: 7,
      slidesToScroll: 7,
      dots: false,
      navs: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          },
        },
        {
          breakpoint: 360,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          },
        }
      ]
    });
  }
  if ($('.template-page .sub-collections-slider').length) {
    $('.template-page .sub-collections-slider').slick({
      slidesToShow: 9,
      dots: false,
      navs: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 8
          },
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 4
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3
          },
        },
      ]
    });
  }
  // Retain the scroll position of a scrollable area when pressing back button
  // change to $(window).on("unload") => Remove the issue on JQuery 3x
  $(function () {
    $(window).on("unload", function () {
      var scrollPosition = $(".template-collection").scrollTop();
      localStorage.setItem("scrollPosition", scrollPosition);
    });
    if (localStorage.scrollPosition) {
      $("template-collection").scrollTop(localStorage.getItem("scrollPosition"));
    }
  });
  function alignHeightSlider(selector) {
    jQuery(selector).css('height', '');
    var minHeight = 0;
    jQuery(selector).each(function () {
      if (minHeight < jQuery(this).outerHeight()) {
        minHeight = jQuery(this).outerHeight();
      }
    });
    if (minHeight > 0) {
      jQuery(selector).css('height', minHeight);
    }
  }
  if ($('.sub-collections')) {
    setTimeout(function () {
      alignHeightSlider('.sub-collections a p');
    }, 500);
    jQuery(window).resize(function () {
      setTimeout(function () {
        alignHeightSlider('.sub-collections a p');
      }, 500);
    });
  }

  if ($('.sub-collections-slider').length) {
    if (!$('.sub-collections-slider .item').length) {
      $('.sub-collections-slider').closest('.sub-collections').remove();
    }
  }

  if ((".description-ct").length) {
    $('.read-more').click(function () {
      $('.read-more').css("display", "none");
      $('.read-less').css("display", "block");
      $('.description-content').addClass("readmore");
    })

    $('.read-less').click(function () {
      $('.read-less').css("display", "none");
      $('.read-more').css("display", "block");
      $('.description-content').removeClass("readmore");
    })
  }

  if ($('#boost-pfs-filter-tree').length) {
    var toggleFilter = setInterval(function () {
      if ($('.boost-pfs-filter-options-wrapper .boost-pfs-filter-option-content .boost-pfs-filter-option-item-list').length) {
        $(".boost-pfs-filter-option-title").each(function () {
          $(this).click(function (e) {
            e.preventDefault();
            var panelParent = $(this).closest('.boost-pfs-filter-option').find('.boost-pfs-filter-option-content');
            var panelChild = $(this).closest('.boost-pfs-filter-option').find('.boost-pfs-filter-option-content .boost-pfs-filter-option-content-inner');
            if ($(panelParent).outerHeight() == 0) {
              panelParent.height($(panelChild).outerHeight(true));
              if ($(panelParent).outerHeight() == 0) {
                $(this).removeClass('filter-close');
                $(this).addClass('filter-open');
              } else {
                $(this).addClass('filter-close');
                $(this).removeClass('filter-open');
              }
            } else {
              panelParent.height(0);
              if ($(panelParent).outerHeight() == 0) {
                $(this).removeClass('filter-close');
                $(this).addClass('filter-open');
              } else {
                $(this).addClass('filter-close');
                $(this).removeClass('filter-open');
              }
            }
          });
        });
      }
    }, 1000);

    setTimeout(function () {
      var titleCollec = '';

      var setCollTitile = setInterval(function () {
        if ($('.boost-pfs-filter-option-collection .boost-pfs-filter-option-item.selected').length) {
          titleCollec = $('.boost-pfs-filter-option-collection .boost-pfs-filter-option-item.selected .boost-pfs-filter-option-value').text();
          $('.boost-pfs-filter-option-collection .boost-pfs-filter-selected-items-mobile').html('<span class="cus-selected-collection">' + titleCollec + '</span>');
          if ($('.cus-selected-collection').length) {
            clearInterval(setCollTitile);
          }
        }
      }, 1000)

      $(document).on('click', '.boost-pfs-filter-option-collection .boost-pfs-filter-option-item.boost-pfs-filter-option-label', function () {
        titleCollec = $(this).find('.boost-pfs-filter-option-value').text();
      });

      setInterval(function () {
        $('.boost-pfs-filter-option-collection .boost-pfs-filter-selected-items-mobile').html('<span class="cus-selected-collection">' + titleCollec + '</span>');
      }, 500);
    }, 1000)
  }

  if ($('#main-collection-filters').length) {
    var distanceCollection = $('#main-collection-filters').offset().top,
      $window = $(window);

    $window.scroll(function () {
      if ($window.scrollTop() >= distanceCollection) {
        $('#main-collection-filters').addClass('go-sticky');
      } else {
        $('#main-collection-filters').removeClass('go-sticky');
      }
    });
  }

  if ($('.sorting-wrapper').length) {
    var distanceSearch = $('.sorting-wrapper').offset().top,
      $window = $(window);

    $window.scroll(function () {
      if ($window.scrollTop() >= distanceSearch) {
        $('.sorting-wrapper').addClass('go-sticky');
      } else {
        $('.sorting-wrapper').removeClass('go-sticky');
      }
    });
  }

  if ($('.template-search').length) {
    var result = setInterval(function () {
      if ($('.boost-pfs-search-result-panel-item.boost-active button').length && $('.product-count__text').length) {
        var txt = $('.boost-pfs-search-result-panel-item.boost-active button').text();
        var numb = txt.match(/\d+/g);
        numb = numb.join('');
        numb = parseInt(numb);
        numb = numb.toLocaleString("en-US");
        $('.product-count__text').text(numb);
        // clearInterval(result);
      }
    }, 1000);

    if (!$('.template-search--empty').length) {
      var empty = setInterval(function () {
        if ($('.result-empty-search').length) {
          $('.template-search').addClass('template-search--empty');
          clearInterval(empty);
        }
      }, 1000)
    }
  }

  $('.template-index .sub-collections-slider').slick({
    slidesToShow: 9,
    dots: false,
    navs: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 8
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 4
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3
        },
      },
    ]
  });

  if ($('.page-home-furniture .sub-collections-slider').length) {
    $('.page-home-furniture .sub-collections-slider').not('.slick-initialized').slick({
      slidesToShow: 9,
      dots: false,
      navs: true,
      infinite: false,
      slidesToScroll: 9,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 8,
            slidesToScroll: 8,
          },
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 6,
          },
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
      ]
    });
  }

  if ($('.collection-feature').length) {
    $('.collection-feature').each(function () {
      let product_grid = $(this).find('.product-grid').not('.slick-initialized'),
        arrows_left = $(this).find('.slider-button--prev'),
        arrows_right = $(this).find('.slider-button--next');

      let init_slick_show_normal = {
        rows: 1,
        dots: true,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 5,
        prevArrow: arrows_left,
        nextArrow: arrows_right,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              rows: 1,
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ]
      };

      let init_slick_show_2_line = {
        rows: 1,
        dots: true,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 5,
        prevArrow: arrows_left,
        nextArrow: arrows_right,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              rows: 2,
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ]
      }
      if ($(this).hasClass('show-normal')) {
        product_grid.slick(init_slick_show_normal)
      } else {
        product_grid.slick(init_slick_show_2_line)
      }
    });
  }
  if ($('.collection-recommend .product-grid').length) {
    $('.collection-recommend .product-grid').slick({
      rows: 1,
      dots: true,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 5,
      prevArrow: $('.collection-title .preview'),
      nextArrow: $('.collection-title .next'),
      responsive: [
        {
          breakpoint: 900,
          settings: {
            rows: 1,
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            rows: 1,
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        }
      ]
    });
  }
  if ($(window).width() < 992) {
    $('.announcement-list .list').slick({
      slidesToShow: 1,
      dots: false,
      navs: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 6000,
      arrows: false
    });
    $('.footer-block__heading').on('click', function () {
      if (!$(this).hasClass('no-accordion')) {
        $(this).parent().find('.footer-block__details-content').slideToggle();
        $(this).toggleClass('has-show');
      }
    });
  }


  // align height

  if ($('.boost-pfs-filter-products').length) {
    function alignHeight(selector, n) {
      var items = jQuery(selector);
      var newArrays = new Array(Math.ceil(items.length / n))
        .fill()
        .map(_ => items.splice(0, n))

      $(newArrays).each(function () {
        jQuery(this).css('height', '');
        var minHeight = 0;
        jQuery(this).each(function () {
          if (minHeight < jQuery(this).outerHeight()) {
            minHeight = jQuery(this).outerHeight();
          }
        });
        if (minHeight > 0) {
          jQuery(this).css('height', minHeight);
        }
      });
    }
    setTimeout(function () {
      if ($(window).width() > 1200) {
        alignHeight('.card-wrapper .h5.card__heading', 4);
        alignHeight('.card-wrapper .card__inner', 4);
        alignHeight('.card-wrapper .price__container', 4);
        alignHeight('.card-wrapper .shipping-time-and-cart', 4);
      } else if ($(window).width() < 750) {
        alignHeight('.card-wrapper .h5.card__heading', 2);
        alignHeight('.card-wrapper .card__inner', 2);
        alignHeight('.card-wrapper .price__container', 2);
        alignHeight('.card-wrapper .shipping-time-and-cart', 2);
      } else {
        alignHeight('.card-wrapper .h5.card__heading', 3);
        alignHeight('.card-wrapper .card__inner', 3);
        alignHeight('.card-wrapper .price__container', 3);
        alignHeight('.card-wrapper .shipping-time-and-cart', 3);
      }
    }, 500);

    jQuery(window).resize(function () {
      if ($(window).width() > 1200) {
        alignHeight('.card-wrapper .h5.card__heading', 4);
        alignHeight('.card-wrapper .card__inner', 4);
        alignHeight('.card-wrapper .price__container', 4);
        alignHeight('.card-wrapper .shipping-time-and-cart', 4);
      } else if ($(window).width() < 750) {
        alignHeight('.card-wrapper .h5.card__heading', 2);
        alignHeight('.card-wrapper .card__inner', 2);
        alignHeight('.card-wrapper .price__container', 2);
        alignHeight('.card-wrapper .shipping-time-and-cart', 2);
      } else {
        alignHeight('.card-wrapper .h5.card__heading', 3);
        alignHeight('.card-wrapper .card__inner', 3);
        alignHeight('.card-wrapper .price__container', 3);
        alignHeight('.card-wrapper .shipping-time-and-cart', 3);
      }
    });
  } else {
    function alignHeight(selector) {
      jQuery(selector).css('height', '');
      var minHeight = 0;
      jQuery(selector).each(function () {
        if (minHeight < jQuery(this).outerHeight()) {
          minHeight = jQuery(this).outerHeight();
        }
      });
      if (minHeight > 0) {
        jQuery(selector).css('height', minHeight);
      }
    }
    setTimeout(function () {
      alignHeight('.sub-collections a p');
      alignHeight('.card-wrapper .card__heading');
      alignHeight('.card-wrapper .card__inner');
      alignHeight('.card-wrapper .price__container');
      alignHeight('.card-wrapper .shipping-time-and-cart');
    }, 500);
    jQuery(window).resize(function () {
      setTimeout(function () {
        alignHeight('.sub-collections a p');
        alignHeight('.card-wrapper .card__heading');
        alignHeight('.card-wrapper .card__inner');
        alignHeight('.card-wrapper .price__container');
        alignHeight('.card-wrapper .shipping-time-and-cart');
      }, 500);
    });
  }


  $(document).on('click', '.close-message', function (e) {
    e.preventDefault();
    $(this).parent().remove();
  });
  // Read more description collection
  $(document).ready(function () {

    if ($('.readmore__blocks .rte').children().length > 1) {
      $(".readmore__blocks .rte").append("<div class='button-readmore'>Read more</div>");
      $(".readmore__blocks .rte").append("<div class='button-readless'>Read less</div>");

      $('.readmore__blocks .button-readmore').click(function () {
        $('.readmore__blocks .rte').children().not(':first-child').show();
        $('.readmore__blocks .button-readmore').hide();
        $('.readmore__blocks .button-readless').show();
      });
      $('.readmore__blocks .button-readless').click(function () {
        $('.readmore__blocks .rte').children().not(':first-child').hide();
        $('.readmore__blocks .button-readless').hide();
        $('.readmore__blocks .button-readmore').show();
      });
    }

  });
  // Add class when click input
  $(document).on('click', '.search__input', function (e) {
    e.preventDefault();
    $('.boost-pfs-enable-instant-search').addClass('search-active');
  });

  $(document).on('click', '#boost-pfs-search-box-mobile', function (e) {
    e.preventDefault();
    var findSearchViewAll = setInterval(function () {
      if ($('.boost-pfs-search-suggestion-mobile-open').length) {
        clearInterval(findSearchViewAll);
        $('.boost-pfs-enable-instant-search').addClass('search-active');
      }
    }, 100);
  });
  // Clear value input
  $(document).on('click', '.predictive-search-status', function (e) {
    $('#boost-pfs-search-box-0').val('');
  });

  $(document).on('click', '.boost-pfs-search-btn-close-suggestion', function (e) {
    $('.boost-pfs-search-btn-clear-suggestion').trigger('click');
  });
  // Prevent submit form when input value empty
  $('.search__input').keyup(function () {
    if ($(this).val().length != 0) {
      $('.search__button').addClass('has-click');
      $('body').addClass('search-active');
    } else {
      $('.search__input').focus();
      $('.search__button').removeClass('has-click');
    }
  });

  // Remove class when click outside input
  $(document).click(function (event) {
    var target = $(event.target);
    if (!target.closest('.search__input').length) {
      $('.boost-pfs-search-suggestion').addClass('hide');
      $('.boost-pfs-enable-instant-search').removeClass('search-active');
    }
  });

  //Disable menu sticky on pages
  if ($(window).width() > 991) {
    $(window).scroll(function () {
      $('.megamenu .main-menu .main-menu-item').each(function () {
        var aTop = $(this).find('.menu-dropdown').height();
        if ($(window).scrollTop() >= aTop) {
          $(this).addClass('on-scroll');
        } else {
          $(this).removeClass('on-scroll');
        }
      });
    });
  }

  //Menu desktop
  $('.megamenu .menu-dropdown .col-submenu.col-promo-banner').parents('.menu-dropdown-content').addClass('has-banner');
  //Check If menu not have level 3
  $('.menu-links.level2.no-child').each(function () {
    var liContent = $(this).find('ul li');
    if (liContent.length == '0') {
      $(this).addClass('no-element');
    }
  });
  //Check promo banner 
  $('.megamenu .menu-dropdown .col-submenu .menu-col').each(function () {
    var countLi = $(this).find('li.menu-links.level2');
    if (countLi.length > 4) {
      $(this).parent().addClass('not-show-banner');
    }
  });

  //Megamenu dobile
  if ($(window).width() < 992) {
    // Toggle slideout megamenu on mobile
    $(document).on('click', '.menu-drawer-container', function () {
      $('.megamenu').addClass('active');
      $('html').addClass('opening-megamenu');
    });
    // Close menu mobile
    $(document).on('click', '.mobile-close-menu', function () {
      $('.megamenu').removeClass('active').removeClass('open-menu-lv1').removeClass('open-menu-lv2');
      $('html').removeClass('opening-megamenu');
      $('.megamenu').scrollTop(0);
      $('.megamenu .main-menu-item .menu-dropdown .dropdown-right-content').removeClass('mobile-active');
      $('.megamenu .main-menu-item .menu-dropdown').removeClass('mobile-active');
    });
    // Toggle sub megamenu on mobile
    $(document).on('click', '.megamenu .main-menu-item.has-dropdown > a', function (e) {
      e.preventDefault();
      $('.megamenu').addClass('open-menu-lv1');
      $(this).parent().find('.menu-dropdown').addClass('mobile-active');
      $('.megamenu').scrollTop(0);
    });
    //Open menu level2
    $(document).on('click', '.menu-links.level2.has-submenu .menulv2', function (e) {
      e.preventDefault();
      $(this).next().slideToggle();
      $(this).toggleClass('active');
      $(this).parents('.menu-links.level2').siblings().find('.menu-sup').slideUp();
      $(this).parents('.menu-links.level2').siblings().find('.menulv2').removeClass('active');
    });
    //Back button
    $('.megamenu-mobile-top-title').on('click', function () {
      $('.megamenu').scrollTop(0);
      if ($('.megamenu').hasClass('open-menu-lv1')) {
        $('.megamenu').removeClass('open-menu-lv1');
      }
      var self = $(this);
      setTimeout(function () {
        self.parent().removeClass('mobile-active');
      }, 300);
    });
  }
  //Newsletter countdown

  const countDownClock = (number = 100, format = 'seconds') => {

    const d = document;
    const daysElement = d.querySelector('.days');
    const hoursElement = d.querySelector('.hours');
    const minutesElement = d.querySelector('.minutes');
    const secondsElement = d.querySelector('.seconds');
    let countdown;
    convertFormat(format);


    function convertFormat(format) {
      switch (format) {
        case 'seconds':
          return timer(number);
        case 'minutes':
          return timer(number * 60);
        case 'hours':
          return timer(number * 60 * 60);
        case 'days':
          return timer(number * 60 * 60 * 24);
      }
    }

    function timer(seconds) {
      const now = Date.now();
      const then = now + seconds * 1000;

      countdown = setInterval(() => {
        const secondsLeft = Math.round((then - Date.now()) / 1000);

        if (secondsLeft <= 0) {
          clearInterval(countdown);
          return;
        };

        displayTimeLeft(secondsLeft);

      }, 500);
    }

    function displayTimeLeft(seconds) {
      if (Math.floor(seconds / 86400) < 10) {
        daysElement.textContent = '0' + Math.floor(seconds / 86400);
      } else {
        daysElement.textContent = Math.floor(seconds / 86400);
      }
      hoursElement.textContent = Math.floor((seconds % 86400) / 3600);
      minutesElement.textContent = Math.floor((seconds % 86400) % 3600 / 60);
      secondsElement.textContent = seconds % 60 < 10 ? `0${seconds % 60}` : seconds % 60;
    }
  }


  /*
    start countdown
    enter number and format
    days, hours, minutes or seconds
  */
  var timeToCount = $('.newsletter-popup .timer-section .timer-down').text();
  countDownClock(timeToCount, 'days');

  //Append timer section to popup newsletter
  var newsTime = setInterval(function () {
    if ($('.needsclick .timer-section').length) {
      clearInterval(newsTime);
    }
    $('.newsletter-popup .timer-section').appendTo('div.needsclick[role=dialog] form.needsclick:not(.success) .needsclick .needsclick.kl-private-reset-css-Xuajs1 .kl-private-reset-css-Xuajs1.kl-private-quill-wrapper-Lkqws1');
    $('.newsletter-popup .newsletter-popup-content .newsletter-popup-title').appendTo('div.needsclick[role=dialog] form.needsclick:not(.success) .needsclick .needsclick.kl-private-reset-css-Xuajs1 .kl-private-reset-css-Xuajs1.kl-private-quill-wrapper-Lkqws1');
    $(document).on('click', 'div.needsclick[role=dialog] form.needsclick div.needsclick:nth-of-type(4) button', function () {

      if ($('div.needsclick[role=dialog] form.needsclick div.needsclick:nth-of-type(3) input[aria-invalid=false]').val().length != '0') {
        $('div.needsclick[role=dialog] form.needsclick .needsclick .needsclick.kl-private-reset-css-Xuajs1 .kl-private-reset-css-Xuajs1.kl-private-quill-wrapper-Lkqws1 .timer-section').remove();
        $('div.needsclick[role=dialog] form.needsclick:not(.success) .needsclick .needsclick.kl-private-reset-css-Xuajs1 .kl-private-reset-css-Xuajs1.kl-private-quill-wrapper-Lkqws1 .newsletter-popup-title').remove();

        clearInterval(newsTime);
      }



      const nextStep = setInterval(() => {
        if (jQuery('div.needsclick[role=dialog] form.needsclick div.needsclick:nth-of-type(3) div.needsclick>div.needsclick').text() != '') {
          $("div.needsclick[role=dialog] form.needsclick").addClass('success');

          clearInterval(nextStep)
        }
      })
    });
  }, 100);
  //Add overflow when show popup newsletter
  var newsTimeTest = setInterval(function () {
    if ($('div.needsclick[role=dialog] .needsclick.klaviyo-form.klaviyo-form-version-cid_1.kl-private-reset-css-Xuajs1').height() != '0') {
      $('div.needsclick[role=dialog] .needsclick.klaviyo-form.klaviyo-form-version-cid_1.kl-private-reset-css-Xuajs1').parents('body').addClass('overflow');
    }

    $(document).on('click', 'div.needsclick[role=dialog] .needsclick.klaviyo-close-form', function () {
      $(this).parents('body').removeClass('overflow');
      clearInterval(newsTimeTest);
    });

  }, 100);
  //Remove overflow when show popup newsletter
  $(document).mouseup(function (e) {
    var container = $("div.needsclick[role=dialog] .needsclick.kl-private-reset-css-Xuajs1 form.needsclick");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.hide();
      container.parents('body').removeClass('overflow');
      clearInterval(newsTimeTest);
    }
  });


  $(".promo-title").click(function () {
    $(".promo-content").slideToggle();
    $(this).toggleClass('active');
  });

  $("#add-promoCode").click(function () {
    var storage = $("#promoValue").val();
    localStorage.setItem("local", storage);  //save the value
  });

  /* 
    function Edit field edit address on my account
  */
  function editAddress(id) {
    var idEdit = id.split("_")[1];
    var idFormEdit = document.getElementById("EditAddress_" + idEdit);
    cancelEditAddress();
    idFormEdit.classList.add("active");
    idFormEdit.scrollIntoView();
  }

  /* 
    function cancel close field edit address on my account
  */
  function cancelEditAddress() {
    var formEdit = document.getElementsByClassName("form-edit__item");
    for (const key in formEdit) {
      if (Number.isInteger(parseInt(key))) {
        formEdit[key].classList.remove("active");
      }
    }
  }
  // Trigger value input
  var inputs = $('#promoValue');
  inputs.keyup(function () {
    $('#discount').val($(this).val());
  });
  // Add search button
  var findSearchViewAll = setInterval(function () {
    if ($('.boost-pfs-search-suggestion-mobile-open').length) {
      clearInterval(findSearchViewAll);
      $('.boost-pfs-search-suggestion-mobile-top-panel form').append('<button class="search__button field__button" aria-label="Search our range..."></button>');
      $('.boost-pfs-search-suggestion-mobile-top-panel').height(47);
    }
  }, 100);

  /*ADDRESS FORM*/

  $(document).on('click', '#new-address', function (e) {
    $("#addAddress").toggleClass('d-none');
  });

  $(document).on('click', '#cancel-addressform', function (e) {
    $("#addAddress").addClass('d-none');
  });

  /*Social Food App */

  $(document).on('click', '#closeYo', function (e) {
    $("#yoHolder").hide();
  });
  if ($('.template-cart').length) {
    var setTime = setInterval(function () {
      if ($('#yoHolder').length) {
        clearInterval(setTime);
        $('#yoHolder').css('visibility', 'hidden');
        $('#yoHolder').css('height', 0);
      }
    })
  }
  /* Remove class when turn off wishlist*/
  $('.bottom-action .swym-button').on('click', function () {
    if ($(this).hasClass('swym-adding')) {
      $(this).removeClass('swym-adding');
    }
  });


  function alignHeightRow(selectorList, coutItem) {
    var interval = setInterval(function () {
      if ($(selectorList).length > 0) {
        var count = 0;
        var numberRow = 1;

        $(selectorList).each(function () {
          count++;
          $(this).addClass('row-' + numberRow);
          alignHeight('.row-' + numberRow);

          if (count == coutItem) {
            numberRow++;
            count = 0;
          }
        });
        clearInterval(interval)
      }
    }, 500)
  }

  if (jQuery(window).width() < 640) {
    alignHeightRow('.page-swym-wishlist .swym-ui-component .swym-wishlist-grid .swym-wishlist-image-wrapper', 2);

    jQuery(window).resize(function () {
      setTimeout(function () {
        alignHeightRow('.page-swym-wishlist .swym-ui-component .swym-wishlist-grid .swym-wishlist-image-wrapper', 2);
      }, 500);
    });
  }

  if (jQuery(window).width() >= 640) {
    alignHeightRow('.page-swym-wishlist .swym-ui-component .swym-wishlist-grid .swym-wishlist-image-wrapper', 3);

    jQuery(window).resize(function () {
      setTimeout(function () {
        alignHeightRow('.page-swym-wishlist .swym-ui-component .swym-wishlist-grid .swym-wishlist-image-wrapper', 3);
      }, 500);
    });
  }

  if (jQuery(window).width() >= 950) {
    alignHeightRow('.page-swym-wishlist .swym-ui-component .swym-wishlist-grid .swym-wishlist-image-wrapper', 4);

    jQuery(window).resize(function () {
      setTimeout(function () {
        alignHeightRow('.page-swym-wishlist .swym-ui-component .swym-wishlist-grid .swym-wishlist-image-wrapper', 4);
      }, 500);
    });
  }


  if (jQuery(window).width() >= 1200) {
    alignHeightRow('.page-swym-wishlist .swym-ui-component .swym-wishlist-grid .swym-wishlist-image-wrapper', 5);

    jQuery(window).resize(function () {
      setTimeout(function () {
        alignHeightRow('.page-swym-wishlist .swym-ui-component .swym-wishlist-grid .swym-wishlist-image-wrapper', 5);
      }, 500);
    });
  }

  $('.afterpay-deals-section .grid-product').slick({
    rows: 1,
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 5,
    prevArrow: $('.collection-title .preview'),
    nextArrow: $('.collection-title .next'),
    responsive: [
      {
        breakpoint: 900,
        settings: {
          rows: 1,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          rows: 1,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      }
    ]
  });
});

/*ALIGN HEIGHT PRODUCT*/
function alignHeight(selector) {

  jQuery(selector).css('height', '');
  var minHeight = 0;

  jQuery(selector).each(function () {
    if (minHeight < jQuery(this).outerHeight()) {
      minHeight = jQuery(this).outerHeight();
    }
  });

  if (minHeight > 0) {
    jQuery(selector).css('height', minHeight);
  }
}
// change currency on wishlist page
if (document.querySelector('.page-swym-wishlist')) {
  const wishlistPrice = () => {
    var counter = setInterval(function () {
      let swymWishListCounter = document.querySelector('.page-swym-wishlist .swym-wishlist-header-counter').textContent;
      if (swymWishListCounter) {
        clearInterval(counter)
        var swymCount = parseInt(swymWishListCounter);
        var findFinalPrice = setInterval(function () {
          if (document.querySelectorAll('.page-swym-wishlist .swym-product-final-price').length == swymCount) {
            clearInterval(findFinalPrice)
            let swymPrice = document.querySelectorAll('.page-swym-wishlist .swym-product-final-price') || '';
            let newCurr = document.querySelector('.page-swym-wishlist').getAttribute('data-wishlist-currency');
            swymPrice.forEach(el => {
              let priceValue = el.textContent;
              let priceNum = priceValue.replace(/[^\d\.]*/g, '');
              let newPrice = document.createElement('span');
              newPrice.textContent = newCurr + priceNum;
              newPrice.setAttribute('class', 'new-price');
              el.appendChild(newPrice);
            })
          }
        }, 300);
      }
    }, 200);
  }
  wishlistPrice();
}






